/**
 * assets/page-uv-c-lamp-kiezen.js
 * Gedrag van sections/page-uv-c-lamp-kiezen.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

  document.addEventListener('DOMContentLoaded', function() {
    const typeButtons = document.querySelectorAll('[data-lamp-type]');
    const lampTypeLabel = document.querySelector('[data-lamp-type-label]');

    typeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selected = this.dataset.lampType;
        
        /* Update aria-pressed*/
        typeButtons.forEach(b => b.setAttribute('aria-pressed', 'false'));
        this.setAttribute('aria-pressed', 'true');
        
        /* Update label*/
        const labelMap = { 't5': 'T5', 'pl-s': 'PL-S', 'pl-l': 'PL-L', 'tl': 'TL/T8', 'overig': 'Merk-specifiek & overig' };
        lampTypeLabel.textContent = labelMap[selected] || selected;
        
        /* Show/hide sections*/
        document.querySelectorAll('[data-show-for-type]').forEach(section => {
          section.classList.add('hidden');
        });
        const targetSection = document.querySelector(`[data-show-for-type="${selected}"]`);
        if (targetSection) targetSection.classList.remove('hidden');
        
        /* Scroll to filter section*/
        setTimeout(() => {
          const scrollTarget = document.querySelector(`#lamp-kiezer-${selected}`);
          if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      });

      /* Keyboard support*/
      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    /* Filter chip logic*/
    /* Multi-dimensie filter state per sectie (T5 gebruikt wattage+voet+pin+lengte; PL/TL/All alleen wattage)*/
    const sectionState = new WeakMap();
    function getState(section) {
      let s = sectionState.get(section);
      if (!s) {
        s = { wattage: 'all', voet: 'all', stand: 'all', lengte: 'all' };
        sectionState.set(section, s);
      }
      return s;
    }
    function applyFilters(section) {
      const grid = section.querySelector('ul');
      if (!grid) return;
      const s = getState(section);
      const activeDims = Object.keys(s).filter(k => s[k] !== 'all');
      let visibleCount = 0;
      grid.querySelectorAll('.uvc-lamp-card').forEach(card => {
        const matches = activeDims.every(dim => {
          const cardVal = card.dataset[dim === 'lengte' ? 'lengte' : dim];
          return cardVal === s[dim];
        });
        card.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });
      const emptyState = section.querySelector('.uvc-empty-state');
      if (emptyState) emptyState.classList.toggle('visible', visibleCount === 0);
      const counter = section.querySelector('.uvc-filter-count');
      if (counter) {
        const total = grid.querySelectorAll('.uvc-lamp-card').length;
        counter.textContent = visibleCount === total ? `Alle ${total} lampen` : `${visibleCount} van ${total} lampen`;
      }
    }

    document.querySelectorAll('.uvc-filter-chip').forEach(chip => {
      chip.addEventListener('click', function() {
        const section = this.closest('section');
        if (!section) return;
        const state = getState(section);
        /* v9: prefer data-filter-dim/data-filter-val; fallback to legacy data-wattage-filter*/
        const dim = this.dataset.filterDim || 'wattage';
        const val = this.dataset.filterVal ?? this.dataset.wattageFilter;
        if (val == null) return;
        /* Update state*/
        state[dim] = val;
        /* Update aria-pressed within SAME dimension-row*/
        const row = this.parentElement;
        if (row) {
          row.querySelectorAll('.uvc-filter-chip').forEach(c => c.setAttribute('aria-pressed', 'false'));
        } else {
          section.querySelectorAll('.uvc-filter-chip').forEach(c => c.setAttribute('aria-pressed', 'false'));
        }
        this.setAttribute('aria-pressed', 'true');
        applyFilters(section);
      });
    });

    /* Reset-knop*/
    document.querySelectorAll('.uvc-filter-reset').forEach(btn => {
      btn.addEventListener('click', function() {
        const section = this.closest('section');
        if (!section) return;
        const state = getState(section);
        state.wattage = 'all'; state.voet = 'all'; state.stand = 'all'; state.lengte = 'all';
        section.querySelectorAll('.uvc-filter-chip').forEach(c => {
          const val = c.dataset.filterVal ?? c.dataset.wattageFilter;
          c.setAttribute('aria-pressed', val === 'all' ? 'true' : 'false');
        });
        applyFilters(section);
      });
    });

    /* Initial state (update counter)*/
    document.querySelectorAll('[data-show-for-type]').forEach(section => {
      if (section.querySelector('.uvc-lamp-card')) applyFilters(section);
    });
  });
